import { Moment } from 'moment';
import * as moment from 'moment';
import { Country } from '../../user-dashboard/shared/country.model';
import {CMBLLangCode} from "../../core/languages";

export class LiteLoginAccess {
  id: string;
  emailAddress: string;
  tmsLoadsInfo: LiteLoginLoadInfo[] = [];
  liteAuthSecretCode: string;
  source: LiteLoginAccessSource = LiteLoginAccessSource.CMAWEB;
  createdAt: Moment;
  activatedAt: Moment;
  expiresAt: Moment;
  firstUsedAt: Moment;
  status: LiteLoginAccessStatus;
  carrierId: string;
  driverCountry: Country = new Country();
  driverLocale: CMBLLangCode;
  driverName: string;
  driverId: string;
  driverPhoneNumber: string;
  cabinLicensePlate: string;
  trailerId: string;
  vehicleId: string;
  isExpired: boolean;

  public static fromDto(p: any): LiteLoginAccess {
    const result = new LiteLoginAccess();
    result.id = p.id;

    result.emailAddress = p.email_address;
    result.liteAuthSecretCode = p.lite_auth_secret_code;
    result.source = p.source;
    result.createdAt = p.created_at ? moment(p.created_at) : null;
    result.activatedAt = p.activated_at ? moment(p.activated_at) : null;
    result.expiresAt = p.expires_at ? moment(p.expires_at) : null;
    result.isExpired = result.expiresAt ? moment().isAfter(result.expiresAt) : false;
    result.firstUsedAt = p.first_used_at ? moment(p.first_used_at) : null;
    result.status = p.status;
    result.carrierId = p.carrier_id;
    result.driverCountry = Country.fromDto(p.driver_country);
    result.driverLocale = p.driver_locale;
    result.driverName = p.driver_name;
    result.driverId = p.driver_id;
    result.driverPhoneNumber = p.driver_phone_number;
    result.cabinLicensePlate = p.cabin_license_plate;
    result.trailerId = p.trailer_id;
    result.vehicleId = p.vehicle_id;

    if (p.tms_loads_info) {
      p.tms_loads_info.forEach(loadInfo => result.tmsLoadsInfo.push(LiteLoginLoadInfo.fromDto(loadInfo)));
    }

    return result;
  }

  public static toDto(access: LiteLoginAccess) {
    const result: any = {};

    result.email_address = access.emailAddress;
    result.lite_auth_secret_code = access.liteAuthSecretCode;
    result.source = access.source;
    result.created_at = access.createdAt;
    result.activated_at = access.activatedAt;
    result.first_used_at = access.firstUsedAt;
    result.status = access.status;
    result.carrier_id = access.carrierId;
    result.driver_country = Country.toDto(access.driverCountry);
    result.driver_locale = access.driverLocale;
    result.driver_name = access.driverName;
    result.driver_id = access.driverId;
    result.driver_phone_number = access.driverPhoneNumber;
    result.cabin_license_plate = access.cabinLicensePlate;
    result.trailer_id = access.trailerId;
    result.vehicle_id = access.vehicleId;

    result.tms_loads_info = [];
    access.tmsLoadsInfo.forEach(loadInfo => {
      result.tms_loads_info.push(LiteLoginLoadInfo.toDto(loadInfo));
    });

    return result;
  }
}

export enum LiteLoginAccessSource {
  CMAWEB = 'CMAWEB',
  CICO_TABLET = 'CICO_TABLET',
}

export enum LiteLoginAccessStatus {
  IN_USE = 'IN_USE',
  ACTIVATED = 'ACTIVATED',
  PENDING = 'PENDING',
  EXPIRED = 'EXPIRED'
}

export class LiteLoginLoadInfo {
  loadId: string;
  loadNumber: string;
  deliveryNumbers: string;
  loadOriginGlid: string;
  loadOriginName: string;
  loadDestinationGlid: string;
  loadDestinationName: string;
  assignedVehicle: string;
  status: string;

  public static fromDto(p: any) {
    const result = new LiteLoginLoadInfo();

    result.loadId = p.load_id;
    result.loadNumber = p.load_number;
    result.deliveryNumbers = p.delivery_numbers;
    result.loadOriginGlid = p.load_origin_glid;
    result.loadOriginName = p.load_origin_name;
    result.loadDestinationGlid = p.load_destination_glid;
    result.loadDestinationName = p.load_destination_name;
    result.assignedVehicle = p.assigned_vehicle;
    result.status = p.status;

    return result;
  }

  public static toDto(loadInfo: LiteLoginLoadInfo) {
    const result: any = {};

    result.load_id = loadInfo.loadId;
    result.load_number = loadInfo.loadNumber;
    result.delivery_numbers = loadInfo.deliveryNumbers;
    result.load_origin_glid = loadInfo.loadOriginGlid;
    result.load_origin_name = loadInfo.loadOriginName;
    result.load_destination_glid = loadInfo.loadDestinationGlid;
    result.load_destination_name = loadInfo.loadDestinationName;
    result.assigned_vehicle = loadInfo.assignedVehicle;
    result.status = loadInfo.status;

    return result;
  }
}
